import { render } from "./QuickAssignModal.vue?vue&type=template&id=4076d826&scoped=true"
import script from "./QuickAssignModal.vue?vue&type=script&lang=js"
export * from "./QuickAssignModal.vue?vue&type=script&lang=js"

import "./QuickAssignModal.vue?vue&type=style&index=0&id=4076d826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4076d826"]])

export default __exports__